import IconButton from '@/global/components/Button/IconButton'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import { useFilterLocaisCentroStore } from '@/global/components/Selects/filter-select'
import dayjs from 'dayjs'
import SP, { usePeriodo } from 'global/components/Selects/SelectPeriodo'
import ContentGuide from 'global/guides/ContentGuide'
import { hasPermission } from 'hooks/useBackendMenu'
import { Trash2Icon } from 'lucide-react'
import { Outlet, useOutletContext } from 'react-router-dom'
import { type Sobreaviso, sobreaviso } from 'service/api'
import { useStore } from 'store'

export default function Sobreaviso() {
    const empresaId = useStore(state => state.companyId)
    const [[dataInicial, dataFinal], setPeriodo] = usePeriodo()
    const { data = [], isLoading } = sobreaviso.useFetch({
        queryParams: {
            empresaId,
            dataInicial,
            dataFinal,
        },
    })

    const useFilter = useFilterLocaisCentroStore()
    const rows = data.filter(useFilter)

    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header
                    label={['Manutenção do ponto', 'Sobreaviso']}
                >
                    <ContentGuide.Filtros
                        SelectEmpresas
                        SelectCentroCusto
                        SelectLocais
                    >
                        <SP.Root
                            onChange={setPeriodo}
                            value={[dataInicial, dataFinal]}
                            allowedTypes={['competencia']}
                            width={320}
                        >
                            <SP.DateSelector />
                            <SP.Buttons />
                        </SP.Root>
                    </ContentGuide.Filtros>
                </ContentGuide.Header>
                <ContentGuide.DataGrid
                    loading={isLoading}
                    onAdd
                    columns={[
                        {
                            field: 'Empresa',
                            headerName: 'Empresa',
                            flex: 1,
                            valueGetter: params =>
                                params.row.Empresa?.nomeFantasia,
                        },
                        {
                            field: 'Funcinario',
                            headerName: 'Funcionario',
                            flex: 1,
                            valueGetter: params => params.row.Funcionario?.nome,
                        },
                        {
                            field: 'horarioInicial',
                            headerName: 'Horario Inicial',
                            width: 125,
                        },
                        {
                            field: 'horarioFinal',
                            headerName: 'Horário Final',
                            width: 125,
                        },
                        {
                            field: 'data',
                            headerName: 'Data',
                            width: 125,
                            type: 'date',
                            valueFormatter: ({ value }) =>
                                value
                                    ? dayjs(value).utc().format('DD/MM/YYYY')
                                    : '',
                        },
                        {
                            ...optionsColumn,
                            field: '__excluir',
                            renderCell: ({ id }) =>
                                hasPermission(['delete', 'Sobreaviso'], () => (
                                    <IconButton
                                        title="Excluir"
                                        href={`${id}/excluir`}
                                    >
                                        <Trash2Icon className="text-error" />
                                    </IconButton>
                                )),
                        },
                    ]}
                    rows={rows}
                    ToolbarProps={{
                        exportButtonProps: {
                            fileName: 'exportacao-sobreaviso',
                        },
                    }}
                />
            </ContentGuide.Card>
            <Outlet context={{ data: rows }} />
        </ContentGuide>
    )
}

export function useSobreavisoOutletContext() {
    return useOutletContext<{
        data?: Sobreaviso[]
    }>()
}
